export const REGISTRATION_FORM_LINE_ITEM = 'REGISTRATION_FORM_LINE_ITEM';
